import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useIsDermatology = () => {
  const router = useRouter()

  return useMemo(() => {
    return ['/dermatologia', '/dermatologista', '/calvicie', '/acne', '/dermatite'].includes(router.pathname)
  }, [router.pathname])
}
